// ── receiptFingerprint.js — 영수증 중복 식별 ───────────────────────
// OCR로 같은 영수증을 두 번 올렸을 때 중복 저장을 방지.
//
// fingerprint = `${date}|${partner-normalized}|${total}`
//   - date: YYYY-MM-DD (OCR이 추출한 거래일)
//   - partner: 공백 제거 + 소문자
//   - total: 공급가액 + 부가세 (또는 totalAmount)
//
// 같은 영수증을 다시 OCR하면 동일한 fingerprint 생성 → 중복 감지.

function normalizePartner(s) {
  return String(s || '').replace(/\s+/g, '').toLowerCase();
}

// OCR 결과(card.ocr)에서 fingerprint 추출
export function fingerprintFromOcr(ocr) {
  if (!ocr) return '';
  const date = String(ocr.date || '').slice(0, 10);
  const partner = normalizePartner(ocr?.partner?.name || ocr?.partnerName || ocr?.vendor || '');
  const total = Math.round(
    Number(ocr.total) || Number(ocr.totalAmount) ||
    ((Number(ocr.supply) || 0) + (Number(ocr.vat) || 0))
  );
  if (!date || !partner || total <= 0) return '';
  return `${date}|${partner}|${total}`;
}

// 거래장부 transaction에서 fingerprint 추출 (저장된 데이터 비교용)
export function fingerprintFromTx(tx) {
  if (!tx) return '';
  // OCR로 저장된 transaction이라면 receiptFingerprint가 박혀있음 (신규 데이터)
  if (tx.receiptFingerprint) return String(tx.receiptFingerprint);
  // 옛 데이터 fallback — date + partnerName + (supply + vat)
  const date = String(tx.date || '').slice(0, 10);
  const partner = normalizePartner(tx.partnerName || tx.vendor || '');
  const total = Math.round((Number(tx.supply) || 0) + (Number(tx.vat) || 0));
  if (!date || !partner || total <= 0) return '';
  return `${date}|${partner}|${total}`;
}

// purchaseLog 문서에서 fingerprint 추출
export function fingerprintFromPurchaseLog(doc) {
  if (!doc) return '';
  if (doc.receiptFingerprint) return String(doc.receiptFingerprint);
  const date = String(doc.date || '').slice(0, 10);
  const partner = normalizePartner(doc.partnerName || doc.vendor || '');
  const total = Math.round(Number(doc.totalAmount) || Number(doc.total) || 0);
  if (!date || !partner || total <= 0) return '';
  return `${date}|${partner}|${total}`;
}

// 거래장부의 fingerprint 합산 (한 영수증이 여러 거래로 분할 저장될 때 첫 거래의 fingerprint만 등록되어도 무방)
// → 단순히 fingerprint Set으로 만들어 비교
export function buildFingerprintSet(items, extractor) {
  const set = new Set();
  for (const it of (items || [])) {
    const fp = extractor(it);
    if (fp) set.add(fp);
  }
  return set;
}
